export default __webpack_public_path__ + "static/media/star-disabled.bcc39764.svg";